import type { z } from 'zod';

import { app_opened, view_switched, pwa_installed, persistent_storage } from './app';
import {
  pattern_created,
  pattern_deleted,
  pattern_forked,
  pattern_imported,
} from './pattern';
import {
  session_started,
  session_paused,
  session_resumed,
  session_resumed_from_history,
  session_completed,
} from './session';
import { wizard_started, wizard_completed } from './wizard';
import { builder_opened, builder_saved } from './builder';
import {
  dsl_parse_failed,
  migration_applied,
  unknown_item_preserved,
  save_failed,
  mirror_skipped,
  session_recovered_from_mirror,
  state_recovered_from_backup,
} from './errors';
import { analytics_toggled } from './settings';

export const eventSchemas = {
  app_opened,
  view_switched,
  pwa_installed,
  persistent_storage,

  pattern_created,
  pattern_deleted,
  pattern_forked,
  pattern_imported,

  session_started,
  session_paused,
  session_resumed,
  session_resumed_from_history,
  session_completed,

  wizard_started,
  wizard_completed,
  builder_opened,
  builder_saved,

  dsl_parse_failed,
  migration_applied,
  unknown_item_preserved,
  save_failed,
  mirror_skipped,
  session_recovered_from_mirror,
  state_recovered_from_backup,

  analytics_toggled,
} as const;

export type EventName = keyof typeof eventSchemas;
export type EventProps<N extends EventName> = z.infer<typeof eventSchemas[N]>;

export { viewName, patternShape } from './_shared';
export type { ViewName, PatternShape } from './_shared';
